import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useEstabelecimento } from '../../hooks/useEstabelecimento';
import { TipoUsuario } from '../../types';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  const location = useLocation();
  const { user } = useAuth();
  const { data: estabelecimento, isLoading } = useEstabelecimento(user?.estabelecimentoId);

  const isFuncionario = user?.tipo === TipoUsuario.FuncionarioEstabelecimento;

  const allMenuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/pdv', label: 'PDV', icon: '🛒' },
    { path: '/produtos', label: 'Produtos', icon: '🧁' },
    { path: '/estoque', label: 'Estoque', icon: '📦' },
    { path: '/encomendas', label: 'Encomendas', icon: '📋' },
    { path: '/clientes', label: 'Clientes', icon: '👥' },
    { path: '/funcionarios', label: 'Funcionários', icon: '👷' },
    { path: '/relatorios', label: 'Relatórios', icon: '📈' },
    { path: '/fechamento-caixa', label: 'Fechamento de Caixa', icon: '💰' },
  ];

  const menuItems = isFuncionario
    ? allMenuItems.filter((item) => item.path === '/pdv')
    : allMenuItems;

  return (
    <div
      className={`h-full bg-gray-800 text-white w-64 fixed left-0 top-0 overflow-y-auto z-40 transform transition-transform duration-300 ease-in-out ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      } lg:translate-x-0`}
    >
      {/* Bot\u00e3o de fechar para mobile */}
      <button
        onClick={onClose}
        className="lg:hidden absolute top-4 right-4 text-white text-3xl hover:text-gray-300 w-8 h-8 flex items-center justify-center"
        aria-label="Fechar menu"
      >
        ×
      </button>

      <div className="p-4 border-b border-gray-700">
        <h1 className="text-xl font-bold pr-8 lg:pr-0">
          🍰 {isLoading ? 'Carregando...' : estabelecimento?.nome || 'Sistema'}
        </h1>
      </div>

      <nav className="p-4">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                onClick={() => {
                  if (window.innerWidth < 1024) onClose();
                }}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                  location.pathname === item.path
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-300 hover:bg-gray-700'
                }`}
              >
                <span className="text-xl">{item.icon}</span>
                <span>{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
